import {
  AuthenticateBody,
  AuthenticateBodyByToken,
  AuthenticateBodyByTokenSchema,
  AuthenticateBodySchema,
  AuthenticateSchema,
  CreateAccountBody,
  CreateAccountBodySchema,
  ForgotPasswordBody,
  ForgotPasswordBodySchema,
  ResetPasswordBody,
  ResetPasswordBodySchema,
  ResetPasswordParams,
  UserSchema,
} from '@/api/_schemas/users'
import { apiBf as api } from '@/config/api-bf'
import { schematize } from '@/services/schematize'

async function getCurrentUser() {
  const { data } = await api.get('api/auth/user')

  return schematize(data, UserSchema)
}

async function registerUser(body: CreateAccountBody) {
  const parsedBody = schematize(body, CreateAccountBodySchema)

  return await api.post('api/registrar', parsedBody)
}

async function authenticateUser(body: AuthenticateBody) {
  const parsedBody = schematize(body, AuthenticateBodySchema)

  const { data } = await api.post('api/auth/login', parsedBody)

  return schematize(data, AuthenticateSchema)
}

async function authenticateUserByToken(body: AuthenticateBodyByToken) {
  const parsedBody = schematize(body, AuthenticateBodyByTokenSchema)

  const { data } = await api.post('api/auth/login-token', parsedBody)

  return schematize(data, AuthenticateSchema)
}

async function forgotPassword(body: ForgotPasswordBody) {
  const parsedBody = schematize(body, ForgotPasswordBodySchema)

  return await api.post('api/auth/recover-password-request', parsedBody)
}

async function resetPassword(
  body: ResetPasswordBody,
  { token }: ResetPasswordParams,
) {
  const parsedBody = schematize(body, ResetPasswordBodySchema)

  return await api.post(`api/auth/recover-password/${token}`, parsedBody)
}

async function logout() {
  return await api.get('api/auth/logout')
}

export {
  registerUser,
  authenticateUser,
  authenticateUserByToken,
  forgotPassword,
  resetPassword,
  getCurrentUser,
  logout,
}
